import { c as _c } from "react-compiler-runtime";
import { MagpieConnection } from 'magpie-lib/connection';
import { AudienceFilter } from 'magpie-lib/models';
import { useEffect } from 'react';
import { useEventCallback } from '../hooks/useEventCallback';
import { getHubSpotWindowInfo } from './hubspotWindow';
import Raven from 'raven-js';
const getSessionIdFromURL = win => new URLSearchParams(win.location.search).get('sessionId');
export const getMagpieSessionId = win => {
  try {
    const sessionIdFromUrl = getSessionIdFromURL(win);
    if (sessionIdFromUrl) {
      return sessionIdFromUrl;
    }
    const {
      sessionId
    } = getHubSpotWindowInfo(win) || {};
    if (sessionId) {
      return sessionId;
    }
    Raven.captureException(new Error('Unable to get magpie session id'), {
      extra: {
        hubspotWindowInfo: window.hubspot,
        search: win.location.search,
        origin: win.location.origin
      }
    });
    return null;
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        hubspotWindowInfo: window.hubspot,
        search: win.location.search,
        origin: win.location.origin
      }
    });
    return null;
  }
};
export const CollaborationSidebarSessionId = getMagpieSessionId(window);
export const buildAudience = () => {
  const builder = AudienceFilter.builder().crossTab(false).crossPortal(true);
  return builder.build();
};
const getTopic = topic => {
  return MagpieConnection.get().forTopic(topic);
};
export const useMagpieTopic = t0 => {
  "use memo";

  const $ = _c(6);
  const {
    topic,
    message,
    onMessage
  } = t0;
  const skip = !onMessage;
  const stableOnMessage = useEventCallback(onMessage);
  let t1;
  let t2;
  if ($[0] !== message || $[1] !== skip || $[2] !== stableOnMessage || $[3] !== topic) {
    t1 = () => {
      if (skip) {
        return;
      }
      const unsubscribe = getTopic(topic).on(message.getType(), stableOnMessage);
      return () => unsubscribe();
    };
    t2 = [message, skip, stableOnMessage, topic];
    $[0] = message;
    $[1] = skip;
    $[2] = stableOnMessage;
    $[3] = topic;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
};
export const CollaborationSidebarAudience = buildAudience();